<template>
  <new-meeting />
</template>

<script>
import NewMeeting from "@/components/3pl/CRM/Meetings/MeetingForm";
export default {
  components: {
    NewMeeting,
  },
};
</script>

<style></style>
